import React from 'react';
import { v4 as uuid } from 'uuid';
import { PropertyType } from '../../../common';
import styles from './GameCategories.module.scss';
import { gameCategoriesListMap } from './GameCategories.const';
import { find } from 'lodash';
import { Button } from 'esa-ui-library';

export const getRows = (
	gameCategories: PropertyType[],
	columns: PropertyType[],
	onAction: (a: string, gameCategory: PropertyType) => void
): PropertyType[] => {
	const getActiveCells = (g: PropertyType): PropertyType[] => {
		const rows: PropertyType[] = [];
		columns.forEach((column) => {
			const field = find(gameCategoriesListMap, ['label', column.label])?.value;
			const cellsMap = {
				game_category_name: <span>{g.name}</span>,
				game_category_id: <span>{g.id}</span>,
			};
			if (field) {
				rows.push((cellsMap as Record<string, JSX.Element>)[field]);
			}
		});
		// rows.unshift(<BulkSelect key={g.internal_game_id} id={`${g.internal_game_id}`} disabled />);
		rows.push(
			<span key={uuid()} className={styles.BtnBox}>
				<Button onClick={() => onAction('edit', g)} title='Edit' small className={styles.Btn} />
			</span>
		);
		return rows;
	};

	const data = gameCategories.map((g) => getActiveCells(g));
	return data;
};
